<template>
    <div class="row">
        <div class="col-12 col-lg-8">
            <div class="form-group">
                <div class="is-required">
                    {{ $t('street') }}:
                </div>

                <div>
                    <input class="form-control" :value="address.street" required
                        @input="updateAddress('street', $event)"
                    >
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <div class="form-group">
                <div class="is-required">
                    {{ $t('building_number') }}:
                </div>

                <div>
                    <input class="form-control" :value="address.building_number" required
                        @input="updateAddress('building_number', $event)"
                    >
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <div class="form-group">
                <div class="is-required">
                    {{ $t('post_code') }}:
                </div>

                <div>
                    <input class="form-control" :value="address.zip" required
                        @input="updateAddress('zip', $event)"
                    >
                </div>
            </div>
        </div>

        <div class="col-12 col-lg-4">
            <div class="form-group">
                <div class="is-required">
                    {{ $t('city') }}:
                </div>

                <div>
                    <input class="form-control" :value="address.city" required
                        @input="updateAddress('city', $event)"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                //
            };
        },

        computed: {
            //
        },

        created() {
            //
        },

        methods: {
            updateAddress(param, e) {
                const address = JSON.parse(JSON.stringify(this.address));

                address[param] = e.target.value;

                this.$emit('updated', address);
            },
        },
    };
</script>
